import AriaHandler from './components/AriaHandler';
import NotificationBanner from './components/NotificationBanner';
import MobileNav from './components/MobileNav';
import Modals from './components/Modals';
import ConvertBlockAssets from './components/ConvertBlockAssets';
import OrientationHandler from './components/OrientationHandler';

import { clickToCopy, setScrollBarWidth } from './components/helpers';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
		window.addEventListener('orientationchange', this.orientationChanged);
		window.addEventListener('convertChanged', this.convertChanged);

		// eslint-disable-next-line camelcase
		window._conv_q = window._conv_q || [];
		// eslint-disable-next-line camelcase
		window._conv_q.push({
			what: 'addListener',
			params: {
				event: 'experience.variation_decided',
				handler: () => window.dispatchEvent(new CustomEvent('convertChanged')),
			},
		});
	}

	init() {
		setScrollBarWidth();
		AriaHandler.init();
		AriaHandler.setAriaHidden();
		NotificationBanner.init();
		MobileNav.init();
		Modals.init();
		ConvertBlockAssets.init();
	}

	resized() {
		setScrollBarWidth();
		AriaHandler.setAriaHidden();
	}

	orientationChanged() {
		OrientationHandler.handle();
	}

	loaded() {
		AriaHandler.setAriaHidden();
		clickToCopy();
	}

	convertChanged() {
		ConvertBlockAssets.loadMissingAssets();
		AriaHandler.setAriaHidden();
	}
}

// Run controller.
new Controller();
